// paragraphHelpers.js
import React from "react";
import { ParagraphsContent } from "./paragraphsContent";
import { ParagraphsImage } from "./paragraphsImage";

const components = {
    paragraph__image: ParagraphsImage,
    paragraph__content: ParagraphsContent
};

export const getParagraph = node => {
    if (components.hasOwnProperty(node.type)) {
        const ParagraphComponent = components[node.type];
        return <ParagraphComponent key={node.id} node={node} />;
    }
    return <p key={node.id}>Unknown type {node.__typename}</p>;
};
